export default {
  app: {
    golf: {
      title: 'Baneinformation',
      hasEVChargingPoint: 'Laddstation för elbilar',
      hasCaddieService: 'Caddie-service',
      hasTrolley: 'Kärra',
      hasBuggy: 'Buggy',
      hasClubRental: 'Klubbuthyrning',
      hasAcademy: 'Akademi',
      hasMarshal: 'Marshal',
      hasPGACertification: 'PGA-certifiering',
      hasTrainingArea: 'Träningsområde',
      hasRestaurant: 'Restaurang',
      hasHotel: 'Hotell',
      hasDogsOnCourse: 'Hundar på banan',
      numberOfHoles: 'Antal hål',
    },
  },
};
